import { render, staticRenderFns } from "./cartFoot.vue?vue&type=template&id=35fff2aa&scoped=true"
import script from "./cartFoot.vue?vue&type=script&lang=js"
export * from "./cartFoot.vue?vue&type=script&lang=js"
import style0 from "./cartFoot.vue?vue&type=style&index=0&id=35fff2aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fff2aa",
  null
  
)

export default component.exports